const BRAND_ICON_ROOT = "/icons/brands";

export interface ModelBrandIdentity {
  company: string;
  name: string;
  family?: string;
}

function icon(name: string): string {
  return `${BRAND_ICON_ROOT}/${name}.webp`;
}

function normalize(value: string | undefined): string {
  return (value ?? "").normalize("NFKC").trim().toLocaleLowerCase("en");
}

function contains(value: string, fragment: string): boolean {
  return value.includes(fragment);
}

const COMPANY_LOGO_BY_KEY = new Map<string, string>([
  ["samsung labs", "samsung"],
  ["三星研究团队", "samsung"],
  ["sandboxaq", "sandboxaq"],
  ["sarvam ai", "sarvam-ai"],
  ["sb intuitions", "sb-intuitions"],
  ["sber robotics center", "sber-robotics-center"],
  ["scaledown", "scaledown"],
  ["sentence transformers", "sentence-transformers"],
  ["seoul national university", "seoul-national-university"],
  ["shanghai innovation institute", "shanghai-innovation-institute"],
  ["shanghai jiao tong university", "shanghai-jiao-tong-university"],
  ["shanghai multimodal embodied ai lab", "shanghai-multimodal-embodied-ai-lab"],
  ["上海多模态具身智能实验室", "shanghai-multimodal-embodied-ai-lab"],
  ["shopee", "shopee"],
  ["shanghai institute of materia medica", "simm"],
  ["simon fraser university", "simon-fraser-university"],
  ["西蒙菲莎大学", "simon-fraser-university"],
  ["singapore management university", "singapore-management-university"],
  ["新加坡管理大学", "singapore-management-university"],
  ["skild ai", "skild-ai"],
  ["south china university of technology", "south-china-university-of-technology"],
  ["华南理工大学", "south-china-university-of-technology"],
  ["southern university of science and technology", "southern-university-of-science-and-technology"],
  ["南方科技大学", "southern-university-of-science-and-technology"],
  ["speck labs", "specklabs"],
  ["speridlabs", "speridlabs"],
  ["stanford university", "stanford-university"],
  ["startlux", "startlux"],
  ["starvla", "starvla"],
  ["stockmark", "stockmark"],
  ["style3d research", "style3d-research"],
  ["style3d 研究团队", "style3d-research"],
  ["sunrising ai", "sunrising-ai"],
  ["supersonic labs", "supersonic-labs"],
  ["superwhisper", "superwhisper"],
  ["tavus", "tavus"],
  ["texas a&m university", "texas-am-university"],
  ["得克萨斯农工大学", "texas-am-university"],
  ["thesys", "thesys"],
  ["renmin university of china", "renmin-university-of-china"],
  ["rock matrix", "rock-matrix"],
  ["ruijin hospital", "ruijin-hospital"],
  ["rumik", "rumik"],
  ["saai", "saai"],
  ["salesforce", "salesforce"],
  ["postal savings bank of china", "postal-savings-bank-of-china"],
  ["preferred networks", "preferred-networks"],
  ["princeton university", "princeton-university"],
  ["quiverai", "quiverai"],
  ["reducto", "reducto"],
  ["information engineering lab", "ielab"],
  ["lncc", "iia-lncc"],
  ["inco ai", "inco-ai"],
  ["inherent", "inherent"],
  ["insilico medicine", "insilico-medicine"],
  ["英矽智能", "insilico-medicine"],
  ["institute of science tokyo", "institute-of-science-tokyo"],
  ["东京科学大学", "institute-of-science-tokyo"],
  ["inworld ai", "inworld"],
  ["jared palmer", "jared-palmer"],
  ["judicialmind", "judicialmind"],
  ["kaist", "kaist"],
  ["kakao", "kakao"],
  ["karakuri", "karakuri"],
  ["ku-agi", "ku-agi"],
  ["kunlun tech", "kunlun-tech"],
  ["kyutai", "kyutai"],
  ["laion", "laion"],
  ["leju robotics", "leju-robotics"],
  ["libertai", "libertai"],
  ["linkup research", "linkup"],
  ["linum", "linum"],
  ["logics-mllm", "logics-mllm"],
  ["multimodal art projection", "m-a-p"],
  ["manycore tech", "manycore-tech"],
  ["massachusetts institute of technology", "massachusetts-institute-of-technology"],
  ["minnesota nlp", "minnesota-nlp"],
  ["明尼苏达大学 nlp 团队", "minnesota-nlp"],
  ["mixedbread", "mixedbread"],
  ["mogan ai", "mogan-ai"],
  ["moondream", "moondream"],
  ["ministry of digital transition and administrative reform, morocco", "morocco-mtnra"],
  ["摩洛哥数字转型与行政改革部", "morocco-mtnra"],
  ["moscow institute of physics and technology", "moscow-institute-of-physics-and-technology"],
  ["moscow state university", "moscow-state-university"],
  ["motif technologies", "motif-technologies"],
  ["multiverse computing", "multiverse-computing"],
  ["musubi labs", "musubi-labs"],
  ["nace.ai", "nace-ai"],
  ["naiveai", "naiveai"],
  ["nanbeige lab", "nanbeige-lab"],
  ["nanjing university", "nanjing-university"],
  ["nankai university", "nankai-university"],
  ["nanyang technological university", "nanyang-technological-university"],
  ["南洋理工大学", "nanyang-technological-university"],
  ["nasa jpl", "nasa"],
  ["nasa", "nasa"],
  ["美国国家航空航天局", "nasa"],
  ["national institute of informatics", "national-institute-of-informatics"],
  ["naver", "naver"],
  ["nex-agi", "nex-agi"],
  ["noiz ai", "noiz-ai"],
  ["northwestern university", "northwestern-university"],
  ["西北大学", "northwestern-university"],
  ["ntt", "ntt"],
  ["national university of singapore", "nus"],
  ["nuva lab", "nuva-lab"],
  ["odyssey", "odyssey"],
  ["openevidence", "openevidence"],
  ["openvdn", "openvdn"],
  ["openwam team", "openwam"],
  ["openwam 研究团队", "openwam"],
  ["orca", "orca"],
  ["panasonic", "panasonic"],
  ["peng cheng laboratory", "peng-cheng-laboratory"],
  ["phonely", "phonely"],
  ["pipecat ai", "pipecat-ai"],
  ["pokee ai", "pokee-ai"],
  ["shanghai ai laboratory", "shanghai-ai-laboratory"],
  ["peking university", "pku-yuangroup"],
  ["mind lab", "mind-lab"],
  ["neura robotics", "neura-robotics"],
  ["openmoss", "openmoss"],
  ["paper instruments", "paper-instruments"],
  ["speechmatics", "speechmatics"],
  ["tether ai research", "tether-ai-research"],
  ["deepdub", "deepdub"],
  ["deepgram", "deepgram"],
  ["deepgrove", "deepgrove"],
  ["desert ant labs", "desert-ant-labs"],
  ["dmis lab", "dmis-lab"],
  ["ebkernel", "ebkernel"],
  ["具脑磐石", "ebkernel"],
  ["edge0", "edge0"],
  ["elyza", "elyza"],
  ["epfl", "epfl"],
  ["eth zurich", "eth-zurich"],
  ["苏黎世联邦理工学院", "eth-zurich"],
  ["fastino", "fastino"],
  ["fastvideo", "fastvideo"],
  ["fermion research", "fermion-research"],
  ["figure", "figure"],
  ["flower labs", "flower-labs"],
  ["frontis ai", "frontis-ai"],
  ["fudan university", "fudan-university"],
  ["galaxea dynamics", "galaxea-dynamics"],
  ["galilai group", "galilai-group"],
  ["genbio ai", "genbio-ai"],
  ["genon", "genon"],
  ["ggquanta", "ggquanta"],
  ["gigaai", "gigaai"],
  ["gsai-ml", "gsai-ml"],
  ["h company", "h-company"],
  ["h2o.ai", "h2o-ai"],
  ["harbin institute of technology", "harbin-institute-of-technology"],
  ["harvey", "harvey"],
  ["heygen", "heygen"],
  ["hi3d", "hi3d"],
  ["hkust", "hkust"],
  ["hong kong university of science and technology (guangzhou)", "hkust"],
  ["香港科技大学(广州)", "hkust"],
  ["hse university", "hse-university"],
  ["humain", "humain"],
  ["humanizer project", "humanizer-team"],
  ["humanizer 项目", "humanizer-team"],
  ["智元机器人", "agibot"],
  ["亚德诺半导体", "analog-devices"],
  ["布朗大学", "brown-university"],
  ["中电信人工智能科技有限公司", "china-telecom-ai"],
  ["感知及互动智能研究中心", "cpii"],
  ["香港中文大学", "cuhk"],
  ["darkps", "darkps"],
  ["deemos", "deemos"],
  ["decagon", "decagon"],
  ["danish foundation models", "danish-foundation-models"],
  ["abacus.ai", "abacus-ai"],
  ["accio lab", "accio-lab"],
  ["ace robotics", "ace-robotics"],
  ["agibot", "agibot"],
  ["ai4bharat", "ai4bharat"],
  ["ai9stars", "ai9stars"],
  ["aikido security", "aikido-security"],
  ["alaya lab", "alaya-lab"],
  ["allspark research", "allspark-research"],
  ["alpha3d", "alpha3d"],
  ["amd", "amd"],
  ["analog devices", "analog-devices"],
  ["artpark at iisc", "artpark-at-iisc"],
  ["astronex robotics", "astronex-robotics"],
  ["audio8", "audio8"],
  ["autotrust ai", "autotrust-ai"],
  ["basically ai", "basically-ai"],
  ["beijing humanoid robot innovation center", "beijing-humanoid-robot-innovation-center"],
  ["bespoke labs", "bespoke-labs"],
  ["blackfrost-ai", "blackfrost-ai"],
  ["bodhan ai", "bodhan-ai"],
  ["boogu", "boogu"],
  ["breezeblue", "breezeblue"],
  ["brown university", "brown-university"],
  ["cactus compute", "cactus-compute"],
  ["cartesia", "cartesia"],
  ["china telecom ai", "china-telecom-ai"],
  ["chinese academy of sciences", "chinese-academy-of-sciences"],
  ["cisco", "cisco"],
  ["cocomatrix", "cocomatrix"],
  ["cogent security", "cogent-security"],
  ["cognition", "cognition"],
  ["convai innovations", "convai-innovations"],
  ["centre for perceptual and interactive intelligence", "cpii"],
  ["creatify labs", "creatify-labs"],
  ["crowdstrike", "crowdstrike"],
  ["cua ai", "cua-ai"],
  ["the chinese university of hong kong", "cuhk"],
  ["cuhk-shenzhen", "cuhk"],
  ["cyberagent", "cyberagent"],
  ["reflection", "reflection"],
  ["elorian", "elorian"],
  ["institute of foundation models", "ifm"],
  ["cerebras systems", "cerebras"],
  ["gnani.ai", "gnani-ai"],
  ["inception42", "inception42"],
  ["respan", "respan"],
  ["typesafe ai", "typesafe-ai"],
  ["groundingpi", "groundingpi"],
  ["ai2", "ai2"],
  ["ai21 labs", "ai21"],
  ["aleph alpha", "aleph-alpha"],
  ["assemblyai", "assemblyai"],
  ["dots.studio", "dots-studio"],
  ["fireworks ai", "fireworks-ai"],
  ["inference.net", "inference-net"],
  ["meshy", "meshy"],
  ["reka ai", "reka"],
  ["snowflake", "snowflake"],
  ["technology innovation institute", "tii"],
  ["together ai", "together-ai"],
  ["topaz labs", "topaz-labs"],
  ["tripo ai", "tripo-ai"],
  ["voyage ai", "voyage-ai"],
  ["yandex", "yandex"],
  ["lighton ai", "lighton-ai"],
  ["vidraft", "vidraft"],
  ["01.ai", "yi"],
  ["aion labs", "aion-labs"],
  ["banana mind ai", "bananamindai"],
  ["bananamind ai", "bananamindai"],
  ["bananamindai", "bananamindai"],
  ["baai", "baai"],
  ["baidu", "baidu"],
  ["baidu apollo", "baidu"],
  ["apodex", "apodex"],
  ["bigcode", "bigcode"],
  ["bigscience", "bigscience"],
  ["bria", "bria"],
  ["cloudflare", "cloudflare"],
  ["cogevol", "cogevol"],
  ["cohere", "cohere"],
  ["deepfloyd", "deepfloyd"],
  ["diffbot", "diffbot"],
  ["eigen ai", "eigen-ai"],
  ["fal", "fal"],
  ["geely", "geely"],
  ["genmo ai", "genmo-ai"],
  ["haomo.ai", "haomo-ai"],
  ["hidream", "hidream"],
  ["hpc-ai tech", "hpc-ai-tech"],
  ["ideogram", "ideogram"],
  ["imagineart", "imagineart"],
  ["inception ai", "inception-ai"],
  ["isomorphic labs", "isomorphic-labs"],
  ["jd", "jd"],
  ["jd.com", "jd"],
  ["jetbrains", "jetbrains"],
  ["illumina", "illumina"],
  ["kandinsky lab", "kandinsky-lab"],
  ["lg", "lg"],
  ["lg ai research", "lg"],
  ["leonardo.ai", "leonardo-ai"],
  ["li auto", "li-auto"],
  ["lightricks", "lightricks"],
  ["luma ai", "luma-ai"],
  ["meituan", "meituan"],
  ["momenta", "momenta"],
  ["moonvalley", "moonvalley"],
  ["muse research", "muse"],
  ["nio", "nio"],
  ["nodemind", "nodemind"],
  ["opengvlab", "opengvlab"],
  ["open pangu", "openpangu"],
  ["openpangu", "openpangu"],
  ["open-r1", "hugging-face"],
  ["ornith ai", "ornith-ai"],
  ["opt gear", "optgear"],
  ["optai", "optgear"],
  ["optgear", "optgear"],
  ["perceptron ai", "perceptron-ai"],
  ["pika", "pika"],
  ["pixart team", "pixart-team"],
  ["pixverse", "pixverse"],
  ["pku-yuangroup", "pku-yuangroup"],
  ["playground ai", "playground-ai"],
  ["qlni", "nodemind"],
  ["recraft", "recraft"],
  ["rednote", "rednote"],
  ["runway", "runway"],
  ["sakana ai", "sakana-ai"],
  ["sand ai", "sand-ai"],
  ["sber", "kandinsky-lab"],
  ["sensenova", "sensenova"],
  ["stability ai", "stability-ai"],
  ["lodestones", "lodestones"],
  ["supra labs", "supralabs"],
  ["supralabs", "supralabs"],
  ["suno", "suno"],
  ["tencent", "tencent"],
  ["tencent ai lab", "tencent"],
  ["tesla", "tesla"],
  ["thomson reuters", "thomson-reuters"],
  ["upstage", "upstage"],
  ["vaelico", "vaelico"],
  ["vectorspacelab", "baai"],
  ["venice ai", "venice-ai"],
  ["vidore", "vidore"],
  ["viggle ai", "viggle"],
  ["xiaomi", "xiaomi"],
  ["xiaomi research", "xiaomi"],
  ["xpeng", "xpeng"]
]);

const OPENAI_PRODUCT_ICON_BY_NAME = new Map<string, string>([
  ["chat latest", "chat-latest"],
  ["chatgpt-4o", "chatgpt-4o-latest"],
  ["chatgpt-image-latest", "chatgpt-image-latest"],
  ["gpt-5 chat", "gpt-5-chat-latest"],
  ["gpt-5.1 chat", "gpt-5.1-chat-latest"],
  ["gpt-5.2 chat", "gpt-5.2-chat-latest"]
]);

const APODEX_MODEL_ICON_BY_NAME = new Map<string, string>([
  ["apodex 1.0", "apodex-1.0"],
  ["apodex 1.1", "apodex-1.1"]
]);

export const OPENAI_MODEL_ICON_BY_NAME: ReadonlyMap<string, string> = new Map([
  ["babbage-002", "babbage-002"],
  ["codex-mini-latest", "codex-mini-latest"],
  ["computer-use-preview", "computer-use-preview"],
  ["davinci-002", "davinci-002"],
  ["gpt image 1", "gpt-image-1"],
  ["gpt image 1.5", "gpt-image-1.5"],
  ["gpt image 2", "gpt-image-2"],
  ["gpt image 2.5 flare", "gpt-image-2.5-flare"],
  ["gpt image 2.5 sunburst", "gpt-image-2.5-sunburst"],
  ["gpt live transcribe", "gpt-live-transcribe"],
  ["gpt transcribe", "gpt-transcribe"],
  ["gpt-3.5 turbo", "gpt-3.5-turbo"],
  ["gpt-4", "gpt-4"],
  ["gpt-4 turbo", "gpt-4-turbo"],
  ["gpt-4.1", "gpt-4.1"],
  ["gpt-4.1 mini", "gpt-4.1-mini"],
  ["gpt-4.1 nano", "gpt-4.1-nano"],
  ["gpt-4.5 preview", "gpt-4.5-preview"],
  ["gpt-4o", "gpt-4o"],
  ["gpt-4o audio", "gpt-4o-audio-preview"],
  ["gpt-4o mini", "gpt-4o-mini"],
  ["gpt-4o mini audio", "gpt-4o-mini-audio-preview"],
  ["gpt-4o mini realtime", "gpt-4o-mini-realtime-preview"],
  ["gpt-4o mini search preview", "gpt-4o-mini-search-preview"],
  ["gpt-4o mini transcribe", "gpt-4o-mini-transcribe"],
  ["gpt-4o mini tts", "gpt-4o-mini-tts"],
  ["gpt-4o realtime", "gpt-4o-realtime-preview"],
  ["gpt-4o search preview", "gpt-4o-search-preview"],
  ["gpt-4o transcribe", "gpt-4o-transcribe"],
  ["gpt-4o transcribe diarize", "gpt-4o-transcribe-diarize"],
  ["gpt-5", "gpt-5"],
  ["gpt-5 mini", "gpt-5-mini"],
  ["gpt-5 nano", "gpt-5-nano"],
  ["gpt-5-codex", "gpt-5-codex"],
  ["gpt-5.1", "gpt-5.1"],
  ["gpt-5.1-codex", "gpt-5.1-codex"],
  ["gpt-5.1-codex mini", "gpt-5.1-codex-mini"],
  ["gpt-5.1-codex-max", "gpt-5.1-codex-max"],
  ["gpt-5.2", "gpt-5.2"],
  ["gpt-5.2-codex", "gpt-5.2-codex"],
  ["gpt-5.3-codex", "gpt-5.3-codex"],
  ["gpt-5.3-codex-spark", "gpt-5.3-codex"],
  ["gpt-5.4", "gpt-5.4"],
  ["gpt-5.4-cyber", "gpt-5.4-cyber"],
  ["gpt-5.4 mini", "gpt-5.4-mini"],
  ["gpt-5.4 nano", "gpt-5.4-nano"],
  ["gpt-5.5", "gpt-5.5"],
  ["gpt-5.5-cyber", "gpt-5.5-cyber"],
  ["gpt-5.6-cyber", "gpt-5.6-cyber"],
  ["gpt-5.6 luna", "gpt-5.6-luna"],
  ["gpt-5.6 sol", "gpt-5.6-sol"],
  ["gpt-5.6 terra", "gpt-5.6-terra"],
  ["gpt-6 astra", "gpt-6-astra"],
  ["gpt-6 luna", "gpt-6-luna"],
  ["gpt-6 sol", "gpt-6-sol"],
  ["gpt-6.1 sol", "gpt-6.1-sol"],
  ["gpt-6.1 terra", "gpt-6.1-terra"],
  ["gpt-audio", "gpt-audio"],
  ["gpt-audio-1.5", "gpt-audio-1.5"],
  ["gpt-audio-mini", "gpt-audio-mini"],
  ["gpt-image-1-mini", "gpt-image-1-mini"],
  ["gpt-live-1", "gpt-live-1"],
  ["gpt-live-1 mini", "gpt-live-1"],
  ["gpt-live-1.1", "gpt-live-1"],
  ["gpt-live-1.1 quip", "gpt-live-1"],
  ["gpt-oss-120b", "gpt-oss-120b"],
  ["gpt-oss-20b", "gpt-oss-20b"],
  ["gpt-oss-safeguard-120b", "gpt-oss-120b"],
  ["gpt-oss-safeguard-20b", "gpt-oss-20b"],
  ["gpt-realtime", "gpt-realtime"],
  ["gpt-realtime mini", "gpt-realtime-mini"],
  ["gpt-realtime-1.5", "gpt-realtime-1.5"],
  ["gpt-realtime-2", "gpt-realtime-2"],
  ["gpt-realtime-2.1", "gpt-realtime-2.1"],
  ["gpt-realtime-2.1 mini", "gpt-realtime-2.1-mini"],
  ["gpt-realtime-translate", "gpt-realtime-translate"],
  ["gpt-realtime-whisper", "gpt-realtime-whisper"],
  ["gpt-red", "gpt-red"],
  ["gpt-rosalind", "gpt-rosalind"],
  ["gpt-rosalind-5.5", "gpt-rosalind"],
  ["o1", "o1"],
  ["o1 preview", "o1-preview"],
  ["o1-mini", "o1-mini"],
  ["o3", "o3"],
  ["o3-deep-research", "o3-deep-research"],
  ["o3-mini", "o3-mini"],
  ["o4-mini", "o4-mini"],
  ["o4-mini-deep-research", "o4-mini-deep-research"],
  ["omni-moderation", "omni-moderation-latest"],
  ["sora 2", "sora-2"],
  ["sora 2 pro", "sora-2-pro"],
  ["text-embedding-3-large", "text-embedding-3-large"],
  ["text-embedding-3-small", "text-embedding-3-small"],
  ["text-embedding-ada-002", "text-embedding-ada-002"],
  ["tts-1", "tts-1"],
  ["tts-1 hd", "tts-1-hd"],
  ["whisper", "whisper-1"]
]);

function resolveAlibabaWanIcon(
  nameKey: string,
  familyKey: string
): string | undefined {
  const keys = [nameKey, familyKey];

  if (
    keys.some(
      (key) =>
        /^wan ?2\.2[- ]animate(?:[- ]|$)/u.test(key) ||
        /^wan[- ]animate[- ]2(?:[- ]|$)/u.test(key)
    )
  ) {
    return "wan2.2-animate";
  }

  if (
    keys.some((key) => /^wan ?2\.1[- ]flf2v(?:[- ]|$)/u.test(key))
  ) {
    return "wan2.1-flf2v";
  }

  if (keys.some((key) => /^wan ?2\.1[- ]vace(?:[- ]|$)/u.test(key))) {
    return "wan2.1-vace";
  }

  if (keys.some((key) => /^wan ?2\.2[- ]s2v(?:[- ]|$)/u.test(key))) {
    return "wan2.2-s2v";
  }

  if (keys.some((key) => /^wan ?2\.2(?:[- ]|$)/u.test(key))) {
    return "wan2.2";
  }

  if (keys.some((key) => /^wan ?2\.1(?:[- ]|$)/u.test(key))) {
    return "wan2.1";
  }

  return undefined;
}

function is360Organization(companyKey: string): boolean {
  // `Qihoo 360`, `360 AI Research Institute` and `360CVGroup` were three company
  // spellings for one publisher and are now one organization, `360 AI`. The
  // retired spellings are not kept: no record carries them, so recognising them
  // would only be dead branches pretending to be a rule.
  return companyKey === "360" || companyKey === "360 ai";
}

export function resolveCompanyLogo(company: string): string | null {
  const companyKey = normalize(company);
  const exactLogo = COMPANY_LOGO_BY_KEY.get(companyKey);

  if (exactLogo) return icon(exactLogo);

  if (contains(companyKey, "krafton")) return icon("krafton");
  if (contains(companyKey, "sk telecom")) return icon("sktelecom");
  if (contains(companyKey, "google")) return icon("google");
  if (contains(companyKey, "spacex") || companyKey === "xai") {
    return icon("spacexai");
  }
  if (contains(companyKey, "openai")) return icon("openai");
  if (contains(companyKey, "alibaba")) return icon("alibaba");
  if (contains(companyKey, "black forest labs")) return icon("bfl");
  if (contains(companyKey, "amap") || contains(companyKey, "高德")) {
    return icon("amap");
  }
  if (contains(companyKey, "adobe")) return icon("adobe");
  if (contains(companyKey, "anthropic")) return icon("anthropic");
  if (contains(companyKey, "baichuan")) return icon("baichuan");
  if (companyKey === "bytedance") return icon("bytedance");
  if (companyKey === "celeris") return icon("celeris");
  if (contains(companyKey, "deepseek")) return icon("deepseek");
  if (companyKey === "deep cogito") return icon("deep-cogito");
  if (contains(companyKey, "elevenlabs")) return icon("elevenlabs");
  if (companyKey === "kuaishou" || contains(companyKey, "快手")) {
    return icon("kuaishou");
  }
  if (contains(companyKey, "kwaipilot")) return icon("kwaipilot");
  if (companyKey === "sapiens ai" || companyKey === "agnes ai") {
    return icon("agnes-ai");
  }
  if (companyKey === "ant group" || contains(companyKey, "蚂蚁集团")) {
    return icon("ant-group");
  }
  if (companyKey === "inclusionai") return icon("inclusionai");
  if (companyKey === "apple") return icon("apple");
  if (companyKey === "amazon" || companyKey === "aws") {
    return icon("amazon");
  }
  if (contains(companyKey, "moonshot")) return icon("moonshot");
  if (contains(companyKey, "liquid ai")) return icon("liquid");
  if (contains(companyKey, "microsoft")) return icon("microsoft");
  if (companyKey === "meta" || contains(companyKey, "meta ai")) {
    return icon("meta-ai");
  }
  if (contains(companyKey, "midjourney")) return icon("midjourney");
  if (contains(companyKey, "minimax")) return icon("minimax");
  if (contains(companyKey, "mistral")) return icon("mistral");
  if (companyKey === "nvidia") return icon("nvidia");
  if (contains(companyKey, "perplexity")) return icon("perplexity");
  if (contains(companyKey, "phind")) return icon("phind");
  if (contains(companyKey, "pruna")) return icon("prunaai");
  if (companyKey === "reve") return icon("reve");
  if (contains(companyKey, "skywork")) return icon("skywork");
  if (contains(companyKey, "stepfun")) return icon("stepfun");
  if (contains(companyKey, "swiss ai")) return icon("swiss-ai");
  if (contains(companyKey, "iflytek")) return icon("spark");
  if (companyKey === "huawei") return icon("huawei");
  if (companyKey === "360") return icon("360");
  if (companyKey === "bilibili") return icon("bilibili");
  if (companyKey === "indexteam") return icon("indexteam");
  if (companyKey === "prismml") return icon("prismml");
  if (companyKey === "ath-maas") return icon("ath-maas");
  if (companyKey === "handoff") return icon("handoff");
  if (companyKey === "poolside") return icon("poolside");
  if (companyKey === "thinking machines lab") {
    return icon("thinking-machines-lab");
  }
  if (companyKey === "shengshu") return icon("shengshu");
  if (companyKey === "openbmb") return icon("openbmb");
  if (companyKey === "arcee ai") return icon("arcee");
  if (companyKey === "krea") return icon("krea");
  if (companyKey === "jina ai") return icon("jina");
  if (companyKey === "featherless.ai") return icon("featherless");
  if (companyKey === "firecrawl") return icon("firecrawl");
  if (companyKey === "dolphin") return icon("dolphin");
  if (companyKey === "fish audio") return icon("fish-audio");
  if (companyKey === "github copilot") return icon("github-copilot");
  if (companyKey === "ibm" || companyKey === "ibm research") {
    return icon("ibm");
  }
  if (companyKey === "cursor") return icon("cursor");
  if (companyKey === "hugging face") return icon("hugging-face");
  if (
    contains(companyKey, "z.ai") ||
    contains(companyKey, "zhipu") ||
    contains(companyKey, "智谱")
  ) {
    return icon("zai");
  }

  return null;
}

export function resolveModelLogo({
  company,
  name,
  family
}: ModelBrandIdentity): string | null {
  const companyKey = normalize(company);
  const nameKey = normalize(name);
  const familyKey = normalize(family);

  if (companyKey === "apodex") {
    const modelIcon =
      APODEX_MODEL_ICON_BY_NAME.get(nameKey) ??
      APODEX_MODEL_ICON_BY_NAME.get(familyKey);
    if (modelIcon) return icon(modelIcon);
  }

  if (is360Organization(companyKey)) return icon("ai360");

  if (nameKey.startsWith("a.x ") || nameKey === "a.x" || familyKey === "a.x k2") {
    return icon("a-x");
  }

  if (companyKey === "bytedance") {
    if (nameKey.startsWith("dola")) return icon("dola");
    if (nameKey.startsWith("doubao") || contains(nameKey, "豆包")) {
      return icon("doubao");
    }
    if (/^seed(?:-| )(?:\d|prover(?:-| |$))/u.test(nameKey)) {
      return icon("seed-text");
    }
  }

  if (companyKey === "lg ai research") {
    return icon("lg-ai-research");
  }

  if (contains(companyKey, "alibaba")) {
    const wanIcon = resolveAlibabaWanIcon(nameKey, familyKey);
    if (wanIcon) return icon(wanIcon);
  }

  if (companyKey === "meta" || contains(companyKey, "meta ai")) {
    return icon("meta");
  }

  if (
    contains(companyKey, "black forest labs") &&
    (nameKey.startsWith("flux") || familyKey.startsWith("flux"))
  ) {
    return icon("flux");
  }

  if (
    contains(companyKey, "swiss ai") &&
    (nameKey.startsWith("apertus") || familyKey.startsWith("apertus"))
  ) {
    return icon("apertus");
  }

  if (companyKey === "kuaishou" || contains(companyKey, "快手")) {
    if (nameKey.startsWith("kling") || familyKey.startsWith("kling")) {
      return icon("kling");
    }
  }

  if (
    (contains(companyKey, "kuaishou") || contains(companyKey, "kwaipilot")) &&
    (familyKey === "kat-coder" || nameKey.startsWith("kat-coder"))
  ) {
    return icon("kwaipilot");
  }

  if (companyKey === "apple") {
    if (nameKey === "apple intelligence server foundation model") {
      return icon("apple-intelligence-server");
    }
    if (nameKey === "apple intelligence on-device foundation model") {
      return icon("apple-intelligence-on-device");
    }
    if (nameKey === "apple foundation models 2025 update") {
      return icon("apple-foundation-models");
    }
  }

  if (
    (companyKey === "amazon" || companyKey === "aws") &&
    (nameKey.startsWith("amazon nova") || familyKey.startsWith("nova") || familyKey.startsWith("amazon nova"))
  ) {
    return icon("nova");
  }

  if (contains(companyKey, "moonshot") && nameKey.startsWith("moonshot")) {
    return icon("moonshot");
  }

  if (contains(companyKey, "openai")) {
    const productIcon = OPENAI_PRODUCT_ICON_BY_NAME.get(nameKey);
    const modelIcon = OPENAI_MODEL_ICON_BY_NAME.get(nameKey);

    if (productIcon) return icon(productIcon);
    if (modelIcon) return icon(modelIcon);
    if (nameKey === "codex") {
      return icon("codex");
    }
    if (nameKey === "sora" || nameKey.startsWith("sora ")) {
      return icon("sora");
    }
    if (/^dall[·\s.-]*e(?:\s|$)/u.test(nameKey)) {
      return icon("dalle");
    }
    if (
      contains(nameKey, "gpt") ||
      contains(nameKey, "chatgpt") ||
      /^o(?:1|3|4)(?:\s|-|$)/u.test(nameKey)
    ) {
      return icon("chatgpt");
    }
  }

  if (contains(companyKey, "google")) {
    if (nameKey === "bert" || familyKey === "bert") return icon("google-bert");
    if (nameKey.startsWith("nano banana")) return icon("nanobanana");
    if (familyKey === "gemma" || nameKey === "gemma") return icon("gemma");
    if (contains(familyKey, "palm") || contains(nameKey, "palm")) {
      return icon("palm");
    }
    if (nameKey.startsWith("gemini") || familyKey.startsWith("gemini")) {
      return icon("gemini");
    }
    return icon("deepmind");
  }

  if (contains(companyKey, "adobe") && (contains(familyKey, "firefly") || nameKey.startsWith("firefly"))) {
    return icon("adobefirefly");
  }
  if (contains(companyKey, "anthropic") && (familyKey.startsWith("claude") || nameKey.startsWith("claude"))) {
    return icon("claude");
  }
  if (
    companyKey === "microsoft ai" &&
    (
      nameKey.startsWith("mai-") ||
      nameKey.startsWith("mai ") ||
      familyKey === "mai" ||
      familyKey.startsWith("mai-") ||
      familyKey.startsWith("mai ")
    )
  ) {
    return icon("mai");
  }
  if (contains(companyKey, "microsoft") && (contains(familyKey, "copilot") || contains(nameKey, "copilot"))) {
    return icon("copilot");
  }
  if ((companyKey === "xai" || contains(companyKey, "spacex")) && (familyKey.startsWith("grok") || nameKey.startsWith("grok"))) {
    return icon("grok");
  }
  if (
    contains(companyKey, "tencent") &&
    (
      familyKey.startsWith("hunyuan") ||
      nameKey.startsWith("hunyuan") ||
      familyKey.startsWith("hy") ||
      nameKey.startsWith("hy")
    )
  ) {
    return icon("hunyuan");
  }
  if (contains(companyKey, "moonshot") && (familyKey === "kimi" || nameKey.startsWith("kimi"))) {
    return icon("kimi");
  }
  if (contains(companyKey, "meituan") && (familyKey === "longcat" || nameKey.startsWith("longcat"))) {
    return icon("longcat");
  }
  if (contains(companyKey, "alibaba") && (familyKey.startsWith("qwen") || nameKey.startsWith("qwen") || nameKey.startsWith("qwq"))) {
    return icon("qwen");
  }
  if (companyKey === "baidu apollo") return icon("apollo");
  if (contains(companyKey, "baidu") && familyKey.startsWith("ernie")) {
    return icon("wenxin");
  }
  if (
    contains(companyKey, "xiaomi") &&
    (nameKey === "unidrivevla" || familyKey === "unidrivevla")
  ) {
    return icon("xiaomi-vla");
  }
  if (contains(companyKey, "xiaomi") && (familyKey.startsWith("mimo") || nameKey.startsWith("mimo"))) {
    return icon("xiaomimimo");
  }
  if (companyKey === "01.ai" && (familyKey === "yi" || nameKey.startsWith("yi"))) {
    return icon("yi");
  }
  if (contains(companyKey, "iflytek") && (familyKey.startsWith("spark") || nameKey.startsWith("spark"))) {
    return icon("spark");
  }

  return resolveCompanyLogo(company);
}

// Model/family artwork first, then the nearest organization in the supplied
// fallback chain (own organization, then its parents) that has a logo.
export function resolveModelCardLogo(
  identity: ModelBrandIdentity,
  organizationLogoCompanies: readonly string[] = []
): string | null {
  const identityLogo = resolveModelLogo(identity);
  if (identityLogo) return identityLogo;

  for (const company of organizationLogoCompanies) {
    const logo = resolveCompanyLogo(company);
    if (logo) return logo;
  }

  return null;
}
